import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { useAlertsStore } from '@tallo/design-system';

import { portfolioQueryKey } from '../queries/portfolio.query';
import { getPropertyIntelligentEscalationsQueryKey } from '../queries/property-intelligent-escalations.query';
import { getPropertyStatisticsQueryKey } from '../queries/property-statistics.query';
import intelligentEscalationService from '../services/property-intelligent-escalations.service';

export const useAnswerIntelligentEscalation = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; escalationId: string; answer: string }) {
      return intelligentEscalationService.answer(payload.escalationId, payload.answer);
    },

    async onSuccess(_, payload) {
      const queryCache = useQueryCache();
      const alertsStore = useAlertsStore();

      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(payload.propertyId) });
      queryCache.invalidateQueries({ key: [portfolioQueryKey] });
      await queryCache.invalidateQueries({ key: getPropertyIntelligentEscalationsQueryKey(payload.propertyId) });

      alertsStore.success('Escalation resolved');
    },

    onError() {
      const alertsStore = useAlertsStore();

      alertsStore.error('Error resolving escalation');
    },
  });
});
